export default __webpack_public_path__ + "static/media/poster-image-1@2x.cf302dea.png";